export default function () {
  return {
    dirtyOriginLeft: 1 / 2,
    dirtyOriginTop: 1 / 2,
    dirtyScaling: 0,
    flippedHorizontally: false,
    flippedVertically: false,
    imageData: null,
    internalImageData: null,
    internalImageHeight: 0,
    internalImageWidth: 0,
    rotated: false,
    panend: true,

    _dirtyOriginLeft: 1 / 2,
    _dirtyOriginTop: 1 / 2,
    _dirtyScaling: 0,

    $imageWidth: 0
  }
}
